/* WorkflowExplorer.js */

"use strict";
const Registrations = require("../RegistrationNamespaces");

module.exports = {
    name: "workflow_explorer",
    label: "Workflows",
    disabled: false,
    order: 7, // Deprecated -- Newer solution uses order from index.js
    app: "GameConsole",
    section: "GameCenter",
    license: ["GLUWARE", "WKF"],
    accessPerm: ["workflowAccess"],
    pageTitle: "Gluware Workflows",
    helpLink: "Config%20Modeling/Workflow-quick-reference.htm",
    // routeData: {
    //     wizardExplorerFilterString: ''
    // },
    //wizardExplorerFilterString: 'Tags[] contains "SD-WAN"',//TODO would like to use this instead of route data
    navIcon: "workflow.solution",
    iconName: "branding.workflowExplorer",
    lmrbNamespaces: [Registrations.WIZARD_EXPLORER_LMRB],
    editorNamespaces: [Registrations.WIZARD_INSTANCE_EDITOR],
};
